import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showMastersMenu, setShowMastersMenu] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          <span className="brand-icon">🔒</span>
          Backup Manager
        </Link>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          ☰
        </button>

        <ul className={`navbar-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <li className={isActive('/') && location.pathname === '/' ? 'active' : ''}>
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>Dashboard</Link>
          </li>
          
          <li className={isActive('/installations') ? 'active' : ''}>
            <Link to="/installations" onClick={() => setMobileMenuOpen(false)}>Installations</Link>
          </li>
          
          <li className={isActive('/backup-configs') ? 'active' : ''}>
            <Link to="/backup-configs" onClick={() => setMobileMenuOpen(false)}>Backup Configs</Link>
          </li>
          
          <li className={isActive('/backup-logs') ? 'active' : ''}>
            <Link to="/backup-logs" onClick={() => setMobileMenuOpen(false)}>Backup Logs</Link>
          </li>
          
          <li 
            className={`dropdown ${isActive('/schedules') || isActive('/sftp-servers') ? 'active' : ''}`}
            onMouseEnter={() => setShowMastersMenu(true)}
            onMouseLeave={() => setShowMastersMenu(false)}
          >
            <span className="dropdown-toggle">Masters ▾</span>
            {showMastersMenu && (
              <ul className="dropdown-menu">
                <li>
                  <Link 
                    to="/schedules" 
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setShowMastersMenu(false);
                    }}
                  >
                    📅 Schedules
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/sftp-servers" 
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setShowMastersMenu(false);
                    }}
                  >
                    🖥️ SFTP Servers
                  </Link>
                </li>
              </ul>
            )}
          </li>
          
          <li className="user-info">
            <span className="user-email">👤 {user?.username || user?.email || 'Admin'}</span>
          </li>
          
          <li>
            <button 
              onClick={() => {
                handleLogout();
                setMobileMenuOpen(false);
              }} 
              className="logout-btn"
            >
              Logout
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;